<div *ngIf="showDrawer$ | async" [@slideIn] class="drawer-container">
    <div class="drawer-content">
        <div class="drawer-heading">
            <span>{{ "pages_title" | translate }}</span>
            <div class="close-drawer-btn" (click)="closeDrawer()">×</div>
        </div>
        <web-pages-drawer-list></web-pages-drawer-list>
    </div>
    <div class="drawer-footer">
        <div class="btn-group">
            <button
                class="btn btn-action"
                [class.btn-loading]="isSaving$ | async"
                [class.disabled]="!(site$ | async)?.created_at || (isButtonDisabled$ | async)"
                (click)="addNewPage()"
            >
                <span class="sp-icon icon-add"></span>
                {{ "add_page" | translate }}
            </button>
        </div>
    </div>
</div>
